export default __webpack_public_path__ + "static/media/dry_cool_small.91852493.svg";